<template>
  <div v-if="object">
    <b-tabs nav-class="sub-menu"
            class="w-100"
            @activate-tab="tabChanged">
      <b-tab active :title="$t('main')"></b-tab>
      <b-tab :title="$t('salaries')" ></b-tab>
      <b-tab :title="$t('materials')" ></b-tab>
      <b-tab :title="$t('insurance')" ></b-tab>
      <b-tab v-if="bonusesEnabled" :title="$t('bonuses')" ></b-tab>
      <b-tab :title="$t('additional_info')" ></b-tab>
    </b-tabs>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  },
  options: {},
})

const store = useStore()

const clinic = computed(() => store.state.auth.clinic)
const additional = computed(() => clinic.value?.clinic_additional)
const bonusesEnabled = computed(() => additional.value?.bonuses_enabled || false)
const views = computed(() => {
  let arr = [
    'main',
    'salaries',
    'materials',
    'insurance',
    'bonuses',
    'additional_info'
  ]
  if(!bonusesEnabled.value) {
    arr = arr.filter(item => item !== 'bonuses')
  }
  return arr
})

onMounted(() => {
  if(props.object && !props.object.id) {
    store.commit('setFullCard', false)
  }
  store.commit('setFormTabActive', views.value[0])
})

const tabChanged = (tab) => {
  store.commit('setFormTabActive', views.value[tab])
}
</script>
